import apiCaller from "../../../helper/apiCall";
import { DCS_DAILY_REPORT_ENDPOINTS } from "../../urls/endpoints";

export const PROGRAM_CODE = "DCSDAILYREPORT";

const buildBody = (params = {}) => {
  const body = { programCode: PROGRAM_CODE };
  Object.entries(params).forEach(([key, value]) => {
    if (key === "export") return;
    if (value === undefined || value === null || value === "") return;
    body[key] = value;
  });
  return body;
};

/** Static catalogue: sections, fields, report columns, options, export limits. */
export const fetchMeta = async () =>
  apiCaller(DCS_DAILY_REPORT_ENDPOINTS.META, "GET");

/** DCS only — form state for a month, and optionally a date inside it. */
export const fetchForm = async ({ month, date } = {}) =>
  apiCaller(DCS_DAILY_REPORT_ENDPOINTS.FORM, "POST", buildBody({ month, date }));

/** Every open field is sent; a blank one goes as an explicit null,*/
const normaliseValues = (values = {}) =>
  Object.fromEntries(
    Object.entries(values)
      .filter(([key]) => key !== "export")
      .map(([key, value]) => [key, value === undefined || value === "" ? null : value])
  );

/** DCS only — save the values of the fields still open on that date. */
export const submitReport = async ({ month, date, values = {} } = {}) =>
  apiCaller(DCS_DAILY_REPORT_ENDPOINTS.SUBMIT, "POST", {
    ...buildBody({ month, date }),
    ...normaliseValues(values),
  });

/** DCS only — its own past submissions. */
export const fetchMySubmissions = async (params = {}) =>
  apiCaller(
    DCS_DAILY_REPORT_ENDPOINTS.MY_SUBMISSIONS,
    "POST",
    buildBody({
      month: params.month,
      fromDate: params.fromDate,
      toDate: params.toDate,
      pageNo: params.pageNo || 1,
      itemsPerPage: params.itemsPerPage || 20,
      sort: params.sort,
    })
  );

/** Admin / Dept Admin / Union Admin — dashboard rows, cards and count. */
export const fetchReportList = async (params = {}) =>
  apiCaller(
    DCS_DAILY_REPORT_ENDPOINTS.LIST,
    "POST",
    buildBody({
      unionId: params.unionId,
      dcsId: params.dcsId,
      month: params.month,
      fromDate: params.fromDate,
      toDate: params.toDate,
      search: params.search,
      pageNo: params.pageNo || 1,
      itemsPerPage: params.itemsPerPage || 20,
      sort: params.sort,
    })
  );

/** One submission with its month's audit history. Scoped to the caller. */
export const fetchReportDetail = async (id) =>
  apiCaller(DCS_DAILY_REPORT_ENDPOINTS.VIEW, "POST", buildBody({ id }));

/** Admin / Dept Admin / Union Admin — server-side Excel or PDF. */
export const exportReport = async (params = {}) =>
  apiCaller(
    DCS_DAILY_REPORT_ENDPOINTS.EXPORT,
    "POST",
    buildBody({
      format: params.format,
      unionId: params.unionId,
      dcsId: params.dcsId,
      month: params.month,
      fromDate: params.fromDate,
      toDate: params.toDate,
      search: params.search,
    })
  );

/** Admin / Dept Admin only — reopen or relock a DCS-month's weeks and payments. */
export const setMonthEditable = async ({ monthlyReportId, isEditable } = {}) =>
  apiCaller(
    DCS_DAILY_REPORT_ENDPOINTS.EDITABLE,
    "POST",
    { programCode: PROGRAM_CODE, monthlyReportId, isEditable: Boolean(isEditable) }
  );
